import { Button } from '../../../atoms';
import { ArrowDownShortIcon, CancelIcon } from '../../../icons';
import { cn } from '../../../utils';
import { type MultiselectRenderPropControls } from '../MultiselectInput.types';

/**
 * Two default icons that can be rendered for a `MultiselectInput`.
 *
 * The first icon is a `X` icon that is used to remove the selected options.
 * The second icon is a cosmetic `ChevronDown` synced with the popover `open` state.
 */
export const MultiselectInputDefaultIcons = <T,>({
  deselectOptions,
  selected,
  open,
  disabled,
}: MultiselectRenderPropControls<T>) => {
  return (
    <>
      <Button
        aria-label="Remove selected options"
        id="multiselect-remove-selected-options"
        onClick={(e) => {
          deselectOptions(selected);
          e.stopPropagation();
        }}
        className={cn(
          'grid place-items-center rounded-full w-6 h-6 p-0 aspect-square opacity-0',
          selected.length > 0 && 'group-hover:opacity-100',
          disabled && 'hidden',
        )}
        variant={'ghost'}
      >
        <CancelIcon />
      </Button>
      <Button
        aria-label="Open multiselect popover"
        id="multiselect-open-popover"
        className={cn(
          'grid place-items-center rounded-full w-6 h-6 p-0 aspect-square',
        )}
        variant={'ghost'}
        disabled={disabled}
      >
        <ArrowDownShortIcon className={cn(open && 'rotate-180')} />
      </Button>
    </>
  );
};
